import { useEffect, useState } from "../../libraries";
import { CustomSpinner, Footer } from "../../common";
import { NavbarLogic } from "../../components";
import { BreadCrumb } from "../BreadCrumb/BreadCrumb.js";
import { CustomImage } from "../../lazyComponent";
import { MetaTag } from "../../customHooks/index.js";
const TermConditionPage = ({ data, BradCrumbData, isLoading }) => {
  const selectedLanguage = localStorage.getItem("i18nextLng");
  const [privacy, setPrivacy] = useState(0);
  useEffect(() => { }, [selectedLanguage, privacy]);

  const getBusinessPartnerPolicyDescitpion = (data) => {
    return selectedLanguage === "thai" &&
      selectedLanguage !== undefined &&
      selectedLanguage !== null
      ? (data?.terms_and_condition?.description_in_thai)
      : (data?.terms_and_condition?.description);
  };

  const getBusinessPartnerPolicyTitle = (data) => {
    return selectedLanguage === "thai" &&
      selectedLanguage !== undefined &&
      selectedLanguage !== null
      ? data?.terms_and_condition?.title_in_thai
      : data?.terms_and_condition?.title;
  };



  const getSubContentSubHeading = (data) => {
    return selectedLanguage === "thai" &&
      selectedLanguage !== undefined &&
      selectedLanguage !== null
      ? (data?.sub_content?.sub_heading_in_thai)
      : (data?.sub_content?.sub_heading);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MetaTag custom_title={data?.terms_and_condition?.title} custom_description={data?.terms_and_condition?.description} />
      <NavbarLogic setPrivacy={setPrivacy} />
       <div className='website-pages-bg-white'>
      <div className="container about-us-outer-container">
        <BreadCrumb data={BradCrumbData} />
        {!(isLoading) ? <>
          <div className="aboutus-img-div">
            <div className="row">
              {data?.terms_and_condition_image_url && (
                <CustomImage
                  src={data?.terms_and_condition_image_url}
                  className="img-fluid"
                  alt="business_partner_image"
                  width={"unset"}
                  height={"unset"}
                />
              )}
              <div
                className={`${data?.terms_and_condition_image_url
                  ? "aboutus-title text-center"
                  : "text-center title-business"
                  }`}
              >
                <p
                  className="description_in_thai"
                  dangerouslySetInnerHTML={{
                    __html: getBusinessPartnerPolicyTitle(data)
                  }}
                ></p>
              </div>
            </div>
          </div>

          <div className="row mt-3">
            {data && (
              <div>
                <p
                  className="description_in_thai"
                  dangerouslySetInnerHTML={{
                    __html: getBusinessPartnerPolicyDescitpion(data),
                  }}
                ></p>
              </div>
            )}
          </div>
          {data?.terms_and_condition_sub_content_data?.map((data, index) => (
            <div key={index} className="row mt-5 mb-5">
              {data?.sub_content_image_url && (
                <>
                  <div
                    className={`col-md-6 ${index % 2 === 0 ? "" : "order-md-2"}`}
                  >
                    <CustomImage
                      src={data?.sub_content_image_url}
                      className="img-fluid"
                      alt="sub_content_image_url"
                      width={"unset"}
                      height={"unset"}
                    />
                  </div>
                  <div
                    className={`col-md-6 ${index % 2 === 0 ? "" : "order-md-1"}`}
                  >
                    <div>
                      <p
                        className="description_in_thai"
                        dangerouslySetInnerHTML={{
                          __html: getSubContentSubHeading(data),
                        }}
                      ></p>
                    </div>
                  </div>
                </>
              )}
              {!data?.sub_content_image_url && (
                <div className="col-md-12">
                  <div>
                    <p
                      className="description_in_thai"
                      dangerouslySetInnerHTML={{
                        __html: getSubContentSubHeading(data),
                      }}
                    ></p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </> : <>
          <CustomSpinner />
        </>}
      </div>

       </div>
      <div className={`${(isLoading) ? 'loader-blog-section' : ''}`}>
        <Footer />
      </div>
    </>
  );
};
export default TermConditionPage;
